import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonSV from '../locales/sv/common.json';
import commonEN from '../locales/en/common.json';
import commonDE from '../locales/de/common.json';

const resources = {
  sv: {
    common: commonSV,
  },
  en: {
    common: commonEN,
  },
  de: {
    common: commonDE,
  },
};

if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'sv');
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS: 'common',
    fallbackLng: 'sv',
    supportedLngs: ['sv', 'en', 'de'],
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
